let injected = false;

export const injectLoadingStyles = (): void => {
	if (injected) return;
	injected = true;

	const style = document.createElement('style');
	style.textContent = `
		@keyframes spin {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		}
		@keyframes pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.5; }
		}
	`;

	document.head.appendChild(style);
};

